// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1dMsM","boxTitle":"Qualiphy_boxTitle__NUA5U","box":"Qualiphy_box__AbcZH","toggleWrap":"Qualiphy_toggleWrap__3oWwH"};